<template>
    <div>
        <pulse-loader :loading="loading"></pulse-loader>

        <div
            v-if="!loading"
            class="input-group"
            v-for="engine in engines"
            :key="engine.id"
        >
            <div class="radio">
                <label
                    class="label-box"
                    :class="{ selected: engine == currentEngine }"
                >
                    <div class="input">
                        <input
                            v-model="currentEngine"
                            type="radio"
                            name="engine"
                            :value="engine"
                        />
                        <i
                            class="active-icon fa fa-check-circle-o"
                            aria-hidden="true"
                        ></i>
                        <i
                            class="inactive-icon fa fa-circle-o"
                            aria-hidden="true"
                        ></i>
                    </div>

                    <div class="text">
                        <h5>{{ engine.name }}</h5>
                        <p v-if="engine.description">
                            {{ engine.description }}
                        </p>
                    </div>

                    <div class="price">
                        <price-diff :value="engine.price"></price-diff>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.input-group {
    width: 100%;
    .radio {
        width: 100%;
    }
}
</style>

<script>
import CatalogModelEngineMixin from "../mixins/CatalogModelEngine";

export default {
    mixins: [CatalogModelEngineMixin],

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    inject: ["locale"],

    created: function () {
        this.getCatalogModelEngines(this.model, { locale: this.locale }).then(
            (response) => {
                this.engines = response.data;
                this.currentEngine = this.engines[0];
                this.loading = false;
            }
        );
    },

    methods: {
        priceDiff(engine, currentEngine) {
            if (engine === currentEngine) {
                return "";
            }
            let enginePrice = engine.price - this.currentEngine.price;
            if (enginePrice === 0) {
                return "";
            }
            enginePrice =
                enginePrice > 0
                    ? `( + €${enginePrice} )`
                    : `( - €${-enginePrice} )`;
            return enginePrice;
        },
    },

    data: function () {
        return {
            engines: null,
            currentEngine: null,
            loading: true,
        };
    },

    watch: {
        currentEngine: function (value) {
            this.$emit("select", value);
        },
    },
};
</script>
